import AddIcon from "../../../../../assets/svg/add-icon";
import Button from "../../../../../components/Button/Button";
import { useNavigate } from "react-router-dom";
import { getClientDomain } from "../../../../../utils/functions/client-code";
import { getHelpDeskTabs } from "../utils/constant";
import { getClientCRMFlag } from "../../../../../utils/constants/clientCustomCRMFlags";
import { ViewSelectorDropdown } from "./AllTickets/components/ViewSelectorDropdown";
import { shouldShowHelpdeskViewSelector } from "../utils/function";
import { useSelector } from "react-redux";
import type { RootState } from "../../../../../redux/store";
import { getHelpdeskLabels } from "../../../../../utils/constants/mappings";

interface DefaultToolbarProps {
  activeTab: string;
  selectedViewId?: string;
  setSelectedViewId?: React.Dispatch<React.SetStateAction<string>>;
  hasMoreViews?: boolean;
  isLoadingMoreViews?: boolean;
  onLoadMoreViews?: () => void | Promise<void>;
}

export const DefaultToolbar = ({
  activeTab,
  selectedViewId = "all_tickets",
  setSelectedViewId,
  hasMoreViews = false,
  isLoadingMoreViews = false,
  onLoadMoreViews,
}: DefaultToolbarProps) => {
  const navigate = useNavigate();
  const clientCode = getClientDomain();
  const region = useSelector(
    (state: RootState) => state?.auth?.client?.region
  );
  const helpdeskLabels = getHelpdeskLabels(region);

  const helpDeskTabs = getHelpDeskTabs(clientCode, region)?.filter(
    (tab) =>
      tab?.id !== "feature-requests" ||
      getClientCRMFlag("hasHelpdeskFeatureRequests", clientCode)
  );

  return (
    <div className="w-full flex items-center justify-between px-4 pt-4 pb-3">
      <div className="flex items-center gap-[24px]">
        <Button
          onClick={() => {
            navigate("/dashboard/crm/helpdesk/create-ticket");
          }}
          Icon={AddIcon}
          iconLeft={true}
          innerText={helpdeskLabels.createTicket}
          buttonContainerClass="h-fit w-fit bg-verba-blue border border-verba-blue hover:bg-verba-blue-hover hover:border-verba-blue-hover rounded-[6px] px-[20px] py-[8px]"
          innerTextClass="text-md font-medium text-fixed-white dark:text-fixed-white-dk whitespace-nowrap"
          iconClass="!w-[16px] !h-[16px] text-fixed-white dark:text-fixed-white-dk shrink-0"
        />
        <div className="h-4 w-px my-auto bg-border-gray dark:bg-border-gray-dk"></div>
        <div className="flex items-start gap-[8px]">
          {helpDeskTabs?.map((tab) => (
            <div key={tab.id} className="flex items-start justify-center">
              {tab?.id === "knowledge-base" && (
                <hr className="h-[16px] w-px mx-6 my-auto bg-border-gray dark:bg-border-gray-dk" />
              )}
              <Button
                key={tab?.id}
                Icon={tab?.icon}
                iconLeft={true}
                innerText={tab?.label}
                onClick={() => {
                  navigate(tab?.path);
                }}
                buttonContainerClass={`min-h-[36px] w-fit hover:bg-hover-effect dark:hover:bg-hover-effect-dk bg-transparent border border-border-gray dark:border-border-gray-dk rounded-[6px] px-[16px] py-[7px] ${tab?.id === activeTab && "border-verba-blue dark:border-verba-blue-dk !bg-applied-filters-tag-bg !dark:bg-applied-filters-tag-bg-dk"}`}
                innerTextClass={`text-md font-medium text-heading-text dark:text-heading-text-dk whitespace-nowrap ${tab?.id === activeTab && "text-verba-blue dark:text-verba-blue-dk"}`}
                iconClass={`${tab?.iconClass} ${tab?.id === activeTab ? "text-verba-blue dark:text-verba-blue-dk" : "text-gray-placeholder dark:text-gray-placeholder-dk"}`}
              />
            </div>
          ))}
        </div>
      </div>
      {shouldShowHelpdeskViewSelector(clientCode, activeTab) && (
        <ViewSelectorDropdown
          selectedViewId={selectedViewId}
          setSelectedViewId={setSelectedViewId}
          hasMoreViews={hasMoreViews}
          isLoadingMoreViews={isLoadingMoreViews}
          onLoadMoreViews={onLoadMoreViews}
        />
      )}
    </div>
  );
};
